import { installationStateClient } from './api-grpc';
import { InstallationState } from '../gen/proto/api/gateway/v1/installation_state_pb';

export const installationStateApi = {
  async getByUuid(uuid: string): Promise<InstallationState> {
    const response = await installationStateClient.getInstallationStateByUuid({ uuid });
    if (!response.installationState) {
      throw new Error('No installation state returned for uuid: ' + uuid);
    }
    return response.installationState;
  },
  async getInstallationStateList(): Promise<InstallationState[]> {
    const response = await installationStateClient.getInstallationStateList({});
    if (!response.installationStates) {
      throw new Error('No installation states');
    }
    return response.installationStates;
  },
  async createInstallationState(name: string, color: string): Promise<InstallationState> {
    const response = await installationStateClient.createInstallationState({
      color: color,
      customName: name,
    });

    if (!response.installationState) {
      throw new Error('No installation state');
    }
    return response.installationState;
  },

  async updateInstallationState(uuid: string, name: string, color: string): Promise<InstallationState> {
    const response = await installationStateClient.updateInstallationState({
      color: color,
      customName: name,
      uuid: uuid,
    });
    if (!response.installationState) {
      throw new Error("Couldn't update installation state");
    }

    return response.installationState;
  },

  async deleteInstallationState(uuid: string): Promise<void> {
    await installationStateClient.deleteInstallationState({ uuid: uuid });
  },
};
